import React from 'react';

export const GiftIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M27.64 13.93a2.03 2.03 0 0 0-2.94-.5l-1.77 1.4a2.02 2.02 0 0 0-2.7-.2l-1.04.81h-2.68c-.43 0-.86-.1-1.24-.29l-.95-.48a5.35 5.35 0 0 0-5.98.8L3.2 20.11a.62.62 0 0 0-.07.84l2.69 3.43c.13.16.31.24.5.24.11 0 .23-.03.33-.09l3.24-2c.23-.14.5-.22.77-.22h7.51c1.06 0 2.11-.36 2.95-1.01l6.07-4.78c.79-.62.99-1.74.45-2.59zm-6.63 1.67a.73.73 0 0 1 .59-.14.7.7 0 0 1 .34.15l-1.05.83c-.1-.17-.22-.33-.36-.46zm5.4-.05l-6.08 4.78a3.5 3.5 0 0 1-2.16.74h-7.51a2.7 2.7 0 0 0-1.44.41l-2.75 1.7-1.99-2.54 4.71-4.26a4.14 4.14 0 0 1 4.56-.61l.95.49c.56.28 1.18.42 1.81.42h2.7c.35 0 .64.29.64.64 0 .34-.26.61-.6.63l-7.52.43a.63.63 0 0 0-.59.66c.02.34.32.6.67.58l7.51-.43A1.88 1.88 0 0 0 21 17.94l4.48-3.54a.74.74 0 0 1 .59-.15.73.73 0 0 1 .34 1.3z"
			fill="currentColor"
		/>
		<path
			d="M12 8.02c-.01 1.98 4.93 4.99 5.08 5.48.14-.51 5.09-3.53 5.08-5.5-.03-3.43-3.83-3.97-5.08-1.14C16.51 5.6 15.51 5 14.54 5c-1.3 0-2.53 1.06-2.54 3.02z"
			fill="currentColor"
		/>
	</svg>
);
